// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"ac95354637c25648","1481":"79e0b7b84b4e00f7","4847":"1b1ce9ef96210c54","8620":"e6a6d0634400a066"}[chunkId] + ".css";
};